// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"tf_a bie_rc bie_qx bie_xr","ForumPosts__contest":"tf_b bie_hq","ForumPosts__counselling":"tf_c"};